import React from 'react'

import clsx from 'clsx'

import Image from 'next/image'

import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { UnknownObject } from 'src/utils/reactTypes'

import storyImg from './storyImg.png'

import s from './StoriesIntro.module.scss'

export const StoriesIntro: React.FC<UnknownObject> = () => {
  return (
    <div className={clsx('container', s.StoriesIntro)}>
      <div className={s.StoriesIntro__content}>
        <Typography
          variant={EnumTypographyVariants.H1}
          text="Reviews and cases"
          className={s.StoriesIntro__title}
        />

        <Typography
          variant={EnumTypographyVariants.H6}
          text="Learn how Insquad helps businesses like yours grows and scale development teams"
          as="p"
        />
      </div>

      <div className={s.StoriesIntro__img}>
        <Image
          src={storyImg.src}
          layout="fill"
          objectFit="cover"
          unoptimized
          alt=""
        />
      </div>
    </div>
  )
}
